export default "__VITE_ASSET__dd8296b1__"